import { render } from "./ManagerPanelHeader.vue?vue&type=template&id=bcd01f9c&scoped=true"
import script from "./ManagerPanelHeader.vue?vue&type=script&lang=js"
export * from "./ManagerPanelHeader.vue?vue&type=script&lang=js"

import "./ManagerPanelHeader.vue?vue&type=style&index=0&id=bcd01f9c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd01f9c"]])

export default __exports__